import { render, staticRenderFns } from "./current-downloads.vue?vue&type=template&id=458000ca&scoped=true"
import script from "./current-downloads.vue?vue&type=script&lang=js"
export * from "./current-downloads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458000ca",
  null
  
)

export default component.exports